/* ========================================
   Annotated Product — reveal animation
   Draws the pointer lines, pops the dots and fades the callouts in once,
   when the section scrolls into view. Without this script (or with reduced
   motion) everything is simply shown.
   ======================================== */

(function () {
  'use strict';

  function init(section) {
    if (!section || section.hasAttribute('data-annotated-ready')) return;
    section.setAttribute('data-annotated-ready', 'true');

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    // Hide the pieces only once we know we can reveal them again.
    section.classList.add('annotated--animate');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        section.classList.add('is-visible');
        observer.disconnect();
      });
    }, { threshold: 0.35 });

    observer.observe(section);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-annotated]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-annotated]');
    if (section) init(section);
  });
})();
